import React, { useEffect, useState } from 'react'
import { firestore } from '../../firebase'
import SingleRegion from './SingleRegion';

function EditRegions() {

    const [regions, setRegions] = useState([]);

    
    useEffect(() => {

        const regionsRef = firestore.collection("bolig-regioner");
        regionsRef.orderBy("region").onSnapshot(({docs}) => {
            const regions = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            setRegions(regions);
        })

    }, [])
    
    return (
        <div>
            
            {regions?.map((region, index) => {
                return (
                    <SingleRegion key={index} region={region} />
                )
            })}
        </div>
    )
}
export default EditRegions